import React from 'react';

function LeyendaContactados({ closeModal }) {
    return (
            <div
                id={'LeyendaContacto'}
                style={{ display: 'none' }}
            >
                <div className="u-1/1">
                    <div className="u-float-left">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14.795"
                            height="14.71"
                            viewBox="0 0 14.795 14.71"
                        >
                            <g
                                id="_08_Icons_01_Control-16x16_01_Control-phone"
                                data-name="08_Icons/01_Control-16x16/01_Control-phone"
                                transform="translate(-0.555 -0.65)"
                            >
                                <path
                                    id="Shape"
                                    d="M11.3,15.1A11.318,11.318,0,0,1,4.1,12C1.3,9.1-.1,4.3,1.5,2.3L2.9.9H5.1L6.6,5,4.8,6.7A5.88,5.88,0,0,0,6.5,9.5a5.47,5.47,0,0,0,2.8,1.7L11,9.5l4.1,1.4V13l-1.4,1.4A3.612,3.612,0,0,1,11.3,15.1ZM3.3,1.8,2.2,2.9c-1.1,1.4,0,5.7,2.7,8.3,2.5,2.6,6.7,3.6,8.2,2.5l1-1V11.6l-2.9-1L9.6,12.2H9.5c-.1,0-1.7,0-3.6-2-2-2-2-3.6-2-3.6V6.4L5.5,4.8l-1.1-3Z"
                                    fill="#FF9317"
                                    stroke="#FF9317"
                                    strokeWidth="0.5"
                                />
                            </g>
                        </svg>
                    </div>
                    <div>
                    &nbsp;&nbsp;&nbsp;Faltan pocos días para el vencimiento
                        del contrato y aún NO SE HA REALIZADO
                        CONTACTO CON EL CLIENTE.
                    </div>
                </div>
                <div className="u-1/1">
                    <div className="u-float-left">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14.795"
                            height="14.71"
                            viewBox="0 0 14.795 14.71"
                        >
                            <g
                                id="_08_Icons_01_Control-16x16_01_Control-phone"
                                data-name="08_Icons/01_Control-16x16/01_Control-phone"
                                transform="translate(-0.555 -0.65)"
                            >
                                <path
                                    id="Shape"
                                    d="M11.3,15.1A11.318,11.318,0,0,1,4.1,12C1.3,9.1-.1,4.3,1.5,2.3L2.9.9H5.1L6.6,5,4.8,6.7A5.88,5.88,0,0,0,6.5,9.5a5.47,5.47,0,0,0,2.8,1.7L11,9.5l4.1,1.4V13l-1.4,1.4A3.612,3.612,0,0,1,11.3,15.1ZM3.3,1.8,2.2,2.9c-1.1,1.4,0,5.7,2.7,8.3,2.5,2.6,6.7,3.6,8.2,2.5l1-1V11.6l-2.9-1L9.6,12.2H9.5c-.1,0-1.7,0-3.6-2-2-2-2-3.6-2-3.6V6.4L5.5,4.8l-1.1-3Z"
                                    fill="#a8adb3"
                                    stroke="#a8adb3"
                                    strokeWidth="0.5"
                                />
                            </g>
                        </svg>
                    </div>
                    <div>
                    &nbsp;&nbsp;&nbsp;Aún no se ha realizado contacto con el
                        cliente.
                    </div>
                </div>
                <div className="u-1/1">
                    <div className="u-float-left">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14.795"
                            height="14.71"
                            viewBox="0 0 14.795 14.71"
                        >
                            <g
                                id="_08_Icons_01_Control-16x16_01_Control-phone"
                                data-name="08_Icons/01_Control-16x16/01_Control-phone"
                                transform="translate(-0.555 -0.65)"
                            >
                                <path
                                    id="Shape"
                                    d="M11.3,15.1A11.318,11.318,0,0,1,4.1,12C1.3,9.1-.1,4.3,1.5,2.3L2.9.9H5.1L6.6,5,4.8,6.7A5.88,5.88,0,0,0,6.5,9.5a5.47,5.47,0,0,0,2.8,1.7L11,9.5l4.1,1.4V13l-1.4,1.4A3.612,3.612,0,0,1,11.3,15.1ZM3.3,1.8,2.2,2.9c-1.1,1.4,0,5.7,2.7,8.3,2.5,2.6,6.7,3.6,8.2,2.5l1-1V11.6l-2.9-1L9.6,12.2H9.5c-.1,0-1.7,0-3.6-2-2-2-2-3.6-2-3.6V6.4L5.5,4.8l-1.1-3Z"
                                    fill="green"
                                    stroke="green"
                                    strokeWidth="0.5"
                                />
                            </g>
                        </svg>
                    </div>
                    <div>
                    &nbsp;&nbsp;&nbsp;Hay uno o más contactos con el cliente.
                    </div>
                </div>
            </div>
         )
}
export default LeyendaContactados;